import request from '@/utils/request'

//获取验证码
export const getVerify = (data) => {
  return request({
    url: '/login/getVerifyCode',
    method: 'post',
    data,
    encrypt: true,
  })
}

//获取验证码-H5
export const getVerifyH5 = (data) => {
  return request({
    url: '/limit/czfs/sendCzfsSmsCode',
    method: 'post',
    data,
    encrypt: true,
  })
}

//短信登录
export const smsLogin = (data) => {
  return request({
    url: '/login/gwLogin',
    method: 'post',
    data,
    encrypt: true,
  })
}

//根据sessionId自动登录
export const sessionLogin = (data) => {
  return request({
    url: '/login/getLoginInfo',
    method: 'post',
    data,
    encrypt: true,
  })
}

//获取openid
export const getOpenId = (data) => {
  return request({
    url: '/mini/gzhGetAccessToken',
    method: 'post',
    data,
    encrypt: true,
  })
}

//获取签名
export const getSignature = (data) => {
  return request({
    url: '/mini/wxGetSignature',
    method: 'post',
    data,
    encrypt: true,
  })
}

//解密渠道id
export const getChannelInfo = (data) => {
  return request({
    url: '/dataStatis/getChannelInfo',
    method: 'post',
    data,
  })
}
